import type { CSSProperties } from "react";
import type { TaskStatus } from "../../../lib/types";

/** Shared chrome for NewTaskModal + TaskEditModal (Sprint 26.0). */

export const STATUSES: TaskStatus[] = ["inbox", "queued", "done", "dropped"];

export const STATUS_LABEL: Record<TaskStatus, string> = {
  inbox: "Inbox",
  queued: "Queued",
  done: "Done",
  dropped: "Dropped",
};

export const modalOverlay: CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.3)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 100,
  fontFamily: "var(--font-sans)",
};

export const modalBox: CSSProperties = {
  background: "var(--color-background-primary)",
  border: "var(--kuvio-border-default)",
  borderRadius: "var(--border-radius-lg)",
  padding: 24,
  width: 460,
  maxWidth: "90vw",
  maxHeight: "90vh",
  overflowY: "auto",
};

export const fieldStyle: CSSProperties = { marginBottom: 16 };

export const labelStyle: CSSProperties = {
  display: "block",
  fontSize: 12,
  fontWeight: 500,
  color: "var(--color-text-secondary)",
  marginBottom: 4,
};

export const inputStyle: CSSProperties = {
  width: "100%",
  fontSize: 13,
  padding: "8px 10px",
  border: "var(--kuvio-border-default)",
  borderRadius: "var(--border-radius-sm)",
  background: "var(--color-background-primary)",
  color: "var(--color-text-primary)",
  fontFamily: "var(--font-sans)",
  boxSizing: "border-box",
};
